window.LMSContactUsForm = function (scope, modalData) {
    // Request a follow up form "RequestFollowUpForm"
    var self = this;
    var formName = "lms-contact-us-form";
    var _protected = BaseForm.call(self, formName, scope);
    self.data = {};

    self.onFormViewLoaded(function () {
        if (modalData.isRegistrationFlow || modalData.isUserExistFlow) {
            self.data.business_name = modalData.business_name;
            self.data.first_name = modalData.user_details.first_name;
            self.data.last_name = modalData.user_details.last_name;
            self.data.email = modalData.user_details.email;
            self.data.phone = modalData.user_details.phone;
            self.data.country = modalData.country;
            self.data.state = modalData.state;
        } else if (modalData.isBuyCreditsFlow) {

            self.data.first_name = modalData.user_details.first_name;
            self.data.last_name = modalData.user_details.last_name;
            self.data.email = modalData.user_details.email;
            self.data.phone = modalData.user_details.phone;

            ProfileAPI.getBrandProfile(modalData.brand_id)
                .then(function (data) {
                    self.data.business_name = data.name;
                })
                .catch(function (err) {
                    console.error(err)
                })
        }
    });

    self.states = US_STATES;

    self.getNationalitiesArray = function () {
        var nationalities = [];
        angular.forEach(NATIONALITY_CODES, function (val, key) {
            nationalities.push({code: key, name: val});
        });
        return _.sortBy(nationalities, 'name');
    };

    self.countries = self.getNationalitiesArray();

    self.changeCountry = function () {
        if (self.data.country && self.data.country.code !== 'US') {
            delete self.data.state;
        }
    };

    self.sendFollowUpRequest = function () {
        var deferred = $q.defer();

        if (self.validator.validate()) {
            var requestFollowUpData = {
                brand_id: modalData.brand_id || null,
                company: self.data.business_name,
                number_of_employees: self.data.employees_number,
                first_name: self.data.first_name,
                last_name: self.data.last_name,
                email: self.data.email,
                phone: self.data.phone,
                country: self.data.country.name,
                message: self.data.message,
                type: modalData.type
            };

            if (self.data.country.code === 'US') {
                requestFollowUpData['state'] = self.data.state.name;
            }

            LMSFollowUpAPI.submitFollowUpRequest(requestFollowUpData)
                .then(function (res) {
                        deferred.resolve({code: "save_success"});
                }, function (err) {
                    console.error(err)
                    deferred.reject({code: "send_error", error: err});
                })

        } else {
            deferred.reject({code: "validate_error"});
        }

        return deferred.promise;
    };

    self.destroy = function () {
        self.validator.validation = {};
    };
};
